<template>
  <div v-if="annual" class="sales-leave-annual" :class="{ 'sales-leave-annual--warning': annual.exceeded, 'sales-leave-annual--compact': compact }">
    <div v-if="!compact" class="sales-leave-annual__title">
      Paid leave in the calendar year (reference {{ annual.limit }} days)
    </div>
    <div v-for="year in annual.years" :key="year.year" class="sales-leave-annual__row">
      <template v-if="compact">
        <span class="sales-leave-annual__compact-label">Paid leave · {{ year.year }}</span>
        <strong>{{ year.total_days }} / {{ annual.limit }} days</strong>
      </template>
      <template v-else>
        <strong>{{ year.year }}</strong>
        <span>
        approved {{ year.approved_days }}<template v-if="year.proposed_days"> + this request {{ year.proposed_days }}</template>
        = {{ year.total_days }} days
        </span>
      </template>
      <span v-if="year.replaced_days && !compact" class="sales-leave-annual__muted">
        (replaces {{ year.replaced_days }} days of this leave)
      </span>
      <span v-if="year.pending_days" class="sales-leave-annual__muted">
        ({{ year.pending_days }} more pending, not counted)
      </span>
      <span v-if="year.exceeded" class="sales-leave-annual__alert">
        exceeds {{ annual.limit }} days by {{ year.excess_days }}
      </span>
    </div>
    <div v-if="annual.exceeded" class="sales-leave-annual__note">
      This is a warning only. The request can still be submitted and approved.
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesLeaveAnnual',
  props: {
    annual: {
      type: Object,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.sales-leave-annual {
  margin: $ui-space-16 0;
  padding: $ui-space-12 $ui-space-16;
  border: 1px solid $ui-line;
  border-radius: $ui-panel-radius;
  background: $ui-surface;
  color: $ui-text;
  font-family: $ui-font-body;
  font-size: $ui-font-size-metadata;
  line-height: 1.5;

  &--warning {
    border-color: $ui-amber;
    background: $ui-amber-soft;
  }

  &--compact {
    margin: 0;
    padding: $ui-space-12;

    .sales-leave-annual__row {
      justify-content: space-between;
    }
  }

  &__compact-label {
    color: $ui-muted;
  }

  &__title {
    margin-bottom: $ui-space-4;
    color: $ui-ink;
    font-weight: 600;
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    gap: $ui-space-4 $ui-space-8;
  }

  &__muted {
    color: $ui-muted;
  }

  &__alert {
    color: $ui-amber;
    font-weight: 600;
  }

  &__note {
    margin-top: $ui-space-4;
    color: $ui-muted;
  }
}
</style>
